
import React from "react";
import { SearchSection } from "@/components/nursing-homes/county/SearchSection";
import type { NursingHomeFilters } from "@/hooks/use-county-page-data";

interface FilterSectionProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  sortBy: string;
  setSortBy: (sort: string) => void;
  selectedCounty: string | null;
  setSelectedCounty: (county: string | null) => void;
  countyOptions: { county: string; county_slug: string }[];
  countiesLoading: boolean;
  nursingHomesCount: number;
  countyName: string;
  filters?: NursingHomeFilters;
  setFilters?: (filters: NursingHomeFilters) => void;
  activeFilterCount?: number;
}

export function FilterSection({
  searchQuery,
  setSearchQuery,
  sortBy,
  setSortBy,
  selectedCounty,
  setSelectedCounty,
  countyOptions,
  countiesLoading,
  nursingHomesCount,
  countyName,
  filters,
  setFilters,
  activeFilterCount,
}: FilterSectionProps) {
  return (
    <div className="mb-8">
      <SearchSection 
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        sortBy={sortBy}
        setSortBy={setSortBy}
        selectedCounty={selectedCounty}
        setSelectedCounty={setSelectedCounty}
        counties={countyOptions}
        countiesLoading={countiesLoading}
        filters={filters}
        setFilters={setFilters}
        activeFilterCount={activeFilterCount}
      />
    </div>
  );
}
